//@flow

import React from "react"
import styled from "styled-components"
import { FormattedMessage } from "react-intl"
import { ForecastMetricTitle, ForecastMetricSubtitle } from "../UI"

import type { Metric } from "../../Shared/AQILegend"

const Group = styled.div`
  margin: 0 auto;
  flex-shrink: 0;
  flex-grow: 0;
  display: flex;
  flex-direction: column;
`

const ForecastMetricTitleGroup = ({
  pollutant,
  innerRefs
}: {
  pollutant: Metric,
  innerRefs?: (el: HTMLElement) => any
}) => (
  <Group>
    <ForecastMetricTitle innerRef={innerRefs}>
      <FormattedMessage id={`kiosk.forecast.metric.${pollutant}.name`} />
    </ForecastMetricTitle>
    <ForecastMetricSubtitle innerRef={innerRefs}>
      <FormattedMessage id={`kiosk.forecast.metric.${pollutant}.description`} />
    </ForecastMetricSubtitle>
  </Group>
)

export default ForecastMetricTitleGroup



// WEBPACK FOOTER //
// ./src/Kiosk/CurrentAirQualityView/ForecastMetric/ForecastMetricTitleGroup.js